<template>
  <button :class="{ 'pointer-events-none': isLoading }" v-ajax-on-before="ajaxBefore" v-ajax-on-success="ajaxSuccess" v-ajax-on-error="ajaxError" :value="value">
    <aw-icon
      v-if="isLoading || icon"
      :icon="isLoading ? 'loading' : icon"
      class="mr-1 w-5 h-5 "
      :class="{ 'animate-spin': isLoading }"
    />
    {{ rewriteValue ? rewriteValue : value }}
  </button>
</template>
<script>
import { trackEvent } from '../../gtm'

export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: 'ajax'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    before: {
      type: Function,
      required: false,
    },
    error: {
      type: Function,
      required: false,
    },
    success: {
      type: Function,
      required: false,
    },
    rewriteValue: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    eventAction: {
      type: String,
      required: false,
    },
    eventLabel: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      statusLoading: false,
    }
  },
  computed: {
    isLoading() {
      return this.mode === 'ajax' ? this.statusLoading : this.loading
    },
  },
  methods: {
    ajaxBefore(settings) {
      this.statusLoading = true
      if (this.before) {
        return this.before(settings)
      }
    },
    ajaxError(error, settings) {
      this.statusLoading = false
      if (this.error) {
        this.error(error, settings)
      }
    },
    ajaxSuccess(payload, response, settings) {
      this.statusLoading = false
      if (this.success) {
        this.success(payload, response, settings)
      }

      if (this.eventAction) {
        trackEvent(this.$route.matched[0].name, this.eventAction, this.eventLabel)
      }
    },
  }
}
</script>